import RelationsTable from 'src/containers/crecer/seminaries/relations/admin/RelationsTable';

const RelationsTablePage = (props) => {
  return <RelationsTable {...props} />;
};

export default RelationsTablePage;
